// extracted by mini-css-extract-plugin
module.exports =  {"vertical":"Progress-vertical-module__vertical___IXqbU"};